module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAAQlBMVEUAAABAgP8zZswrauondusybeQxa+Qxa+QxbeUxbOMxbeMybOMwbeQxbOIybOMxbOMxbOMxbOMxbOMxbOMxbOMxbOOEXUqNAAAAFXRSTlMABAUMDTg5Q0Sct7nDxM7z9Pn7/P51w1WIAAAAf0lEQVQ4y+2USw6AIAxEEb8ICqJz/6u6IC6oVo1REhPeruEt2kkYIX6PMfy0A+CnFHKjLRisrmO3nXDC1EbyCFVxa1QKYyR7yBDWEEUXJgkv7t9NXh/I/UJPW/p35O92zmnkNFLK24c9pMBMq6Dk3JJWwUXJdLS+HKc63YhMSlaHxBxX4PW8/QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/course/ckkj@2x.png
// module id = WuVf
// module chunks = 0